// import React from 'react'

// const ProductDoc = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default ProductDoc


// import React from 'react'

// const CreateSupplierProduct = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default CreateSupplierProduct


import { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Box,
  Breadcrumbs,
  IconButton,
  Link,
  Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStyles } from "../../assets/styles/Theme.tsx";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { PageDataContext } from "../../utils/common/PageDataContext.tsx";
import { useLocation } from "react-router-dom";
import { externalgetApi } from "../../services/externalApis.tsx";
import { SUPPLIER_API_06 } from "../../api/ApiModel.tsx";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants.tsx";
import ProductsAgreement from "../../components/products/ProductsAgreement";
import ProductsBasicInfo from "../../components/products/ProductsBasicInfo";
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function ProductDoc() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const [value, setValue] = useState(0);
const [datasupbranch, setDatasupbranch] = useState(null);
  const location = useLocation();
  const { selectedItem, actionText,supname } = location.state || {};

  const [supplierType, setSupplierType] = useState(
    selectedItem?.suptypecode === "2" ? "Cooperate" : "Individual"
  );

  const [supproductcode, setsupproductcode] = useState(selectedItem?.supproductcode || 0);

  const handleSupplierTypeChange = (event) => {
    setSupplierType(event.target.value);
  };

  useEffect(() => {
    setPageData({
      title: "Supplier Products",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  
    const fetchDatasupbranch = async () => {
      try {
        const result = await externalgetApi(SUPPLIER_API_06, "get", {
          supproductcode:selectedItem.supproductcode,
  
          STS: CON_STATUS_ACTIVE,
        });
  
        setDatasupbranch(result);
        console.log("result", result);
     
      } catch (err) {
       
    
      }
    };
  

   useEffect(() => {
    if (actionText === "Edit" && selectedItem) {
      fetchDatasupbranch(selectedItem.supproductcode);
    }
  }, [actionText, selectedItem]);

  useEffect(() => {
    if (selectedItem?.suptypecode) {
      setSupplierType(
        selectedItem.suptypecode == "2" ? "Cooperate" : "Individual"
      );
    }
  }, [selectedItem]);

  const goBackToView = () => {
    navigate(-1);
  };
  return (
    <>
      {" "}
      <Box sx={styles.box_breadcrumb}>
        <Tooltip title="Back to All Items" arrow sx={styles.breadcrumb_tooltip}>
          <IconButton
            aria-label="back"
            sx={styles.btn_breadcrumb_back}
            onClick={goBackToView}
          >
            <ArrowBackIcon sx={styles.btn_breadcrumb_back_icon} />
          </IconButton>
        </Tooltip>
        <Typography sx={styles.breadcrumb_divider}>|</Typography>

        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            Home
          </Link>
          <Link
            sx={styles.breadcrumb_link}
            underline="hover"
            // href=""
          >
            Supplier Management
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
    Supplier Products Document          </Link>
        </Breadcrumbs>
      </Box>
      <Box sx={styles.box_add_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 12, sm: 8, md: 8, lg: 8, xl: 8 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {" "}
                <Typography sx={styles.appbar_title}>
                 Supplier Product Document
                </Typography>
                  <Typography sx={{ color: "text.secondary", fontSize: 12 }}>
   {supname}
  </Typography>
              </Typography>
            </Grid>
           
          </Grid>
        </AppBar>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={styles.add_form_page_container}
        >
          {/* Tab panel */}
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>

            <ProductsAgreement
              supproductcode={supproductcode}
              setsupproductcode={setsupproductcode}
            />
         
          </Box>
          
          {/* {supproductcode !== 0 && ( */}
        

         
      <>     


{/*             
               <TabPanel value={value} index={3} dir={theme.direction}>
              <SupplierPenalty />
            </TabPanel>
            <TabPanel value={value} index={4} dir={theme.direction}  setsupproductcode={setsupproductcode} >
               <SupplierBank supproductcode={supproductcode} setsupproductcode={setsupproductcode} />
            </TabPanel> */}


          </>
       {/* )}  */}
        </Box>
        {/* <Box sx={styles.add_form_page_button_box}>
          <Button
            variant="outlined"
            size="medium"
            sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="medium"
            sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
          >
            Confirm
          </Button>
        </Box> */}
      </Box>
    </>
  );
}

export default ProductDoc;
